import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    ArrowLeft,
    UserCircle2,
    Info,
    LogOut,
    Shield,
    ChevronRight,
    X,
    CheckCircle2
} from "lucide-react";

import api from "../services/api";


function More() {
    const navigate = useNavigate();

    const storedUser =
        JSON.parse(
            localStorage.getItem("user")
        );

    const [user, setUser] =
        useState(storedUser);

    const [permissions, setPermissions] =
        useState([]);

    const [loading, setLoading] =
        useState(true);

    const [activePopup, setActivePopup] =
        useState(null);


    // ========================================
    // LOAD CURRENT USER + PERMISSIONS
    // ========================================

    useEffect(() => {
        const loadAccount = async () => {
            try {
                const response =
                    await api.get("/auth/me");

                setUser(
                    response.data.user
                );

                setPermissions(
                    response.data.permissions || []
                );

                localStorage.setItem(
                    "user",
                    JSON.stringify(
                        response.data.user
                    )
                );

            } catch (error) {
                console.error(
                    "Unable to load account information",
                    error
                );

            } finally {
                setLoading(false);
            }
        };


        loadAccount();
    }, []);


    // ========================================
    // LOGOUT
    // ========================================

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        window.location.href =
            "/login";
    };


    // ========================================
    // CLOSE POPUP
    // ========================================

    const closePopup = () => {
        setActivePopup(null);
    };


    // ========================================
    // PERMISSION LABEL
    // ========================================

    const formatPermission = (key) => {
        return String(key || "")
            .replace(/_/g, " ")
            .toLowerCase()
            .replace(
                /\b\w/g,
                letter =>
                    letter.toUpperCase()
            );
    };


    return (
        <div className="mobile-app">


            {/* ========================================
                HEADER
            ======================================== */}

            <header className="page-header">

                <button
                    className="back-button"
                    onClick={() =>
                        navigate(
                            "/dashboard"
                        )
                    }
                >
                    <ArrowLeft
                        size={21}
                    />
                </button>


                <div>

                    <h1>
                        More
                    </h1>

                    <p>
                        Account and app settings
                    </p>

                </div>

            </header>


            <main className="more-content">


                {/* ========================================
                    PROFILE CARD
                ======================================== */}

                <section className="more-profile-card">

                    <div className="more-profile-icon">

                        <UserCircle2
                            size={30}
                        />

                    </div>


                    <div className="more-profile-info">

                        <small>
                            Signed in as
                        </small>


                        <h2>
                            {
                                user?.full_name ||
                                "User"
                            }
                        </h2>


                        <p>
                            @{user?.username}
                        </p>


                        <span>
                            {user?.role}
                        </span>

                    </div>

                </section>


                {loading && (

                    <div className="loading-state">
                        Loading account...
                    </div>

                )}


                {/* ========================================
                    ACCOUNT OPTIONS
                ======================================== */}

                <section className="more-section">

                    <h3>
                        Account
                    </h3>


                    <button
                        className="more-option"
                        type="button"
                        onClick={() =>
                            setActivePopup(
                                "account"
                            )
                        }
                    >

                        <div className="more-option-icon">

                            <UserCircle2
                                size={20}
                            />

                        </div>


                        <div className="more-option-text">

                            <strong>
                                My Account
                            </strong>

                            <small>
                                View your account information
                            </small>

                        </div>


                        <ChevronRight
                            size={18}
                        />

                    </button>


                    <button
                        className="more-option"
                        type="button"
                        onClick={() =>
                            setActivePopup(
                                "access"
                            )
                        }
                    >

                        <div className="more-option-icon">

                            <Shield
                                size={20}
                            />

                        </div>


                        <div className="more-option-text">

                            <strong>
                                Access
                            </strong>

                            <small>
                                Your role and permissions
                            </small>

                        </div>


                        <ChevronRight
                            size={18}
                        />

                    </button>

                </section>


                {/* ========================================
                    APPLICATION
                ======================================== */}

                <section className="more-section">

                    <h3>
                        Application
                    </h3>


                    <button
                        className="more-option"
                        type="button"
                        onClick={() =>
                            setActivePopup(
                                "about"
                            )
                        }
                    >

                        <div className="more-option-icon">

                            <Info
                                size={20}
                            />

                        </div>


                        <div className="more-option-text">

                            <strong>
                                About PriceManager
                            </strong>

                            <small>
                                Product price management system
                            </small>

                        </div>


                        <ChevronRight
                            size={18}
                        />

                    </button>

                </section>


                {/* ========================================
                    LOGOUT
                ======================================== */}

                <button
                    className="more-logout-button"
                    type="button"
                    onClick={
                        handleLogout
                    }
                >
                    <LogOut
                        size={18}
                    />

                    Logout
                </button>

            </main>


            {/* ========================================
                MY ACCOUNT POPUP
            ======================================== */}

            {activePopup ===
                "account" && (

                <div
                    className="more-popup-overlay"
                    onClick={
                        closePopup
                    }
                >

                    <div
                        className="more-popup"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <div className="more-popup-header">

                            <div>

                                <p>
                                    Account
                                </p>

                                <h2>
                                    My Account
                                </h2>

                            </div>


                            <button
                                type="button"
                                onClick={
                                    closePopup
                                }
                            >
                                <X
                                    size={19}
                                />
                            </button>

                        </div>


                        <div className="account-detail-list">


                            <div className="account-detail-row">

                                <span>
                                    Full Name
                                </span>

                                <strong>
                                    {
                                        user?.full_name ||
                                        "-"
                                    }
                                </strong>

                            </div>


                            <div className="account-detail-row">

                                <span>
                                    Username
                                </span>

                                <strong>
                                    @{
                                        user?.username ||
                                        "-"
                                    }
                                </strong>

                            </div>


                            <div className="account-detail-row">

                                <span>
                                    Role
                                </span>

                                <strong>
                                    {
                                        user?.role ||
                                        "-"
                                    }
                                </strong>

                            </div>


                            <div className="account-detail-row">

                                <span>
                                    Status
                                </span>

                                <strong
                                    className={
                                        user?.status ===
                                        "ACTIVE"
                                            ? "account-active"
                                            : "account-inactive"
                                    }
                                >
                                    {
                                        user?.status ||
                                        "-"
                                    }
                                </strong>

                            </div>

                        </div>

                    </div>

                </div>

            )}


            {/* ========================================
                ACCESS POPUP
            ======================================== */}

            {activePopup ===
                "access" && (

                <div
                    className="more-popup-overlay"
                    onClick={
                        closePopup
                    }
                >

                    <div
                        className="more-popup"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <div className="more-popup-header">

                            <div>

                                <p>
                                    Security
                                </p>

                                <h2>
                                    Access
                                </h2>

                            </div>


                            <button
                                type="button"
                                onClick={
                                    closePopup
                                }
                            >
                                <X
                                    size={19}
                                />
                            </button>

                        </div>


                        <div className="access-role-card">

                            <span>
                                Account Role
                            </span>

                            <strong>
                                {
                                    user?.role ||
                                    "-"
                                }
                            </strong>

                        </div>


                        <h3 className="access-permissions-title">
                            Permissions
                        </h3>


                        {user?.role ===
                        "OWNER" ? (

                            <div className="owner-access-message">

                                <Shield
                                    size={20}
                                />

                                <div>

                                    <strong>
                                        Full Access
                                    </strong>

                                    <p>
                                        The owner has access
                                        to all PriceManager
                                        features.
                                    </p>

                                </div>

                            </div>

                        ) : permissions.length ===
                        0 ? (

                            <div className="no-permissions-message">

                                No additional permissions
                                have been assigned.

                            </div>

                        ) : (

                            <div className="access-permission-list">

                                {permissions.map(
                                    permission => (

                                    <div
                                        className="access-permission-item"
                                        key={
                                            permission.permission_key
                                        }
                                    >

                                        <CheckCircle2
                                            size={16}
                                        />


                                        <div>

                                            <strong>
                                                {
                                                    permission.permission_name ||
                                                    formatPermission(
                                                        permission.permission_key
                                                    )
                                                }
                                            </strong>


                                            {permission.description && (

                                                <small>
                                                    {
                                                        permission.description
                                                    }
                                                </small>

                                            )}

                                        </div>

                                    </div>

                                ))}

                            </div>

                        )}

                    </div>

                </div>

            )}


            {/* ========================================
                ABOUT POPUP
            ======================================== */}

            {activePopup ===
                "about" && (

                <div
                    className="more-popup-overlay"
                    onClick={
                        closePopup
                    }
                >

                    <div
                        className="more-popup"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <div className="more-popup-header">

                            <div>

                                <p>
                                    Application
                                </p>

                                <h2>
                                    PriceManager
                                </h2>

                            </div>


                            <button
                                type="button"
                                onClick={
                                    closePopup
                                }
                            >
                                <X
                                    size={19}
                                />
                            </button>

                        </div>


                        <div className="about-app-icon">

                            PM

                        </div>


                        <div className="about-app-content">

                            <h3>
                                PriceManager
                            </h3>


                            <p>
                                A business product price
                                management system for
                                maintaining product prices,
                                availability, Excel imports,
                                exports and price-change
                                history.
                            </p>


                            <div className="about-version">

                                <span>
                                    Version
                                </span>

                                <strong>
                                    1.0.0
                                </strong>

                            </div>

                        </div>

                    </div>

                </div>

            )}

        </div>
    );
}


export default More;